<template>
  <svg viewBox="0 0 360 360" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="360"
      height="360"
      rx="24"
      transform="matrix(1 0 0 -1 0 360)"
      :fill="`url(#${scopeId})`"
    />
    <defs>
      <linearGradient
        :id="scopeId"
        x1="180"
        y1="113"
        x2="180"
        y2="322"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="currentColor" />
        <stop offset="1" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>
<script>
export default {
  data() {
    return {
      // 添加随机后缀确保组件级唯一性
      scopeId: 'role_fill_' + Math.random().toString(36).slice(2, 11),
    }
  },
}
</script>
